import { useCallback } from "react";
import { useReauthenticate } from "./useReauthenticate.js";
const useSignUp = (authImplementation, setAuthProviderState, getCurrentUser) => {
  const reauthenticate = useReauthenticate(
    authImplementation,
    setAuthProviderState,
    getCurrentUser
  );
  return useCallback(
    async (options) => {
      const signupOutput = await authImplementation.signup(options);
      await reauthenticate();
      return signupOutput;
    },
    [authImplementation, reauthenticate]
  );
};
export {
  useSignUp
};
